// Shift kasir yang lupa ditutup. Aturan SAMA dengan server (backend utils/shiftKasir.js) dan aplikasi Flutter (lib/shift/shift_kasir.dart):
// lewat batas peringatan kasir diingatkan; lewat batas kunci transaksi baru diblokir sampai shift ditutup (hitung uang di laci).
// Angka batas dibawa data shift dari server (`batas`); bila tidak ada dipakai angka bawaan ini.
export const BATAS_PERINGATAN_JAM = 12;
export const BATAS_KUNCI_JAM = 24;

const JAM_MS = 60 * 60 * 1000;

/** Lama shift terbuka dalam jam (desimal), 0 bila waktu buka tidak terbaca. */
export const umurJam = (dibukaAt, sekarang = Date.now()) => {
  const t = new Date(dibukaAt).getTime();
  return Number.isFinite(t) ? Math.max(0, (sekarang - t) / JAM_MS) : 0;
};

/** 'normal' | 'peringatan' | 'terkunci' untuk shift yang sedang terbuka. */
export const tingkatShift = (shift, sekarang = Date.now()) => {
  if (!shift || !shift.dibukaAt) return 'normal';
  const peringatan = Number(shift.batas?.peringatanJam) || BATAS_PERINGATAN_JAM;
  const kunci = Number(shift.batas?.kunciJam) || BATAS_KUNCI_JAM;
  const j = umurJam(shift.dibukaAt, sekarang);
  if (j >= kunci) return 'terkunci';
  if (j >= peringatan) return 'peringatan';
  return 'normal';
};

/** "13 jam", "2 hari" untuk ditampilkan ke kasir. */
export const teksUmur = (jam) => {
  if (jam < 1) return 'kurang dari 1 jam';
  if (jam < 48) return `${Math.floor(jam)} jam`;
  return `${Math.floor(jam / 24)} hari`;
};
